export const getDomain = (): string => {
	const domain = window.location.hostname;
	// for local development, but we still want to use
	// keycloak on test server
	if (domain === "localhost") {
		return "template-test.emergo.dev";
	}
	return domain;
};
